import React from "react";
import { hydrate, render } from "react-dom";
import App from "./App";
import { isDev, getClientByDomain } from "./helpers";
import { Client, Stage } from "./types/Utils";
const defaultClient = 'AOL';

function getParameterByName(name: string) {
  var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

const clientCode: Client =
  (getParameterByName("client")?.toUpperCase() as Client) ||
  getClientByDomain(window.location.hostname, defaultClient) ||
  defaultClient;

const windowObjectDefaultProps = {
  isEnabled: true,
};

if (window && window.AOPropositionBarWidget) {
  window.AOPropositionBarWidget = {
    ...window.AOPropositionBarWidget,
    ...windowObjectDefaultProps,
  };
} else if (window) {
  window.AOPropositionBarWidget = { ...windowObjectDefaultProps };
}
const stage = getParameterByName('stage') as Stage || Stage.Live;

const APP = <App client={clientCode} stage={stage} />;
const RENDER_EL = document.getElementById("header-propositionBar");



if(RENDER_EL){

  const onFinishRender = () => {
    if (window) {
      window.dispatchEvent(new CustomEvent('Findability-PropositionBarLoaded'));
    }
  }

  if (isDev) {
    render(APP, RENDER_EL, onFinishRender);
  } else {
    hydrate(APP, RENDER_EL, onFinishRender);
  }


}

